import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteNavbar } from "./components/Navbar/SiteNavbar.jsx";
import { HeroSection } from "./components/Hero/HeroSection.jsx";
import { PartnersSection } from "./components/Partners/PartnersSection.jsx";
import { ProductsSection } from "./components/Products/ProductsSection.jsx";
import { BenefitsSection } from "./components/Benefits/BenefitsSection.jsx";
import { AboutPreviewSection } from "./components/About/AboutPreviewSection.jsx";
import { FooterSection } from "./components/Footer/FooterSection.jsx";
import { ContactSection } from "./components/Contact/ContactSection.jsx";
import { ProductDetailsPage } from "./components/Productdetails/ProductDetailsPage.jsx";
import { AboutPage } from "./components/About/Page/AboutPage.jsx";
import { ContactPage } from "./components/Contact/ContactPage/ContactPage.jsx";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./i18n";

function LanguageSettings() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const updateDocumentLanguage = (language) => {
      const isArabic = language.startsWith("ar");
      document.documentElement.lang = isArabic ? "ar" : "en";
      document.documentElement.dir = isArabic ? "rtl" : "ltr";
      document.title = isArabic
        ? "رودز ريفلكتورز | مورد معدات السلامة على الطرق في السعودية"
        : "Road's Reflectors | Road Safety Equipment Supplier in Saudi Arabia";
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute(
          "content",
          isArabic
            ? "مؤسسة رودز ريفلكتورز لمعدات السلامة على الطرق في المملكة العربية السعودية: الألواح العاكسة، وعلامات الطرق، ومصدات الصدمات، والعواكس الشمسية."
            : "Road's Reflectors Trading Est. — supplier of road safety equipment in Saudi Arabia: reflective sheeting, road studs, solar cat's eyes, crash cushions, Scorpion truck-mounted attenuators and more."
        );
      localStorage.setItem("language", isArabic ? "ar" : "en");
    };

    updateDocumentLanguage(i18n.resolvedLanguage || i18n.language);
    i18n.on("languageChanged", updateDocumentLanguage);
    return () => i18n.off("languageChanged", updateDocumentLanguage);
  }, [i18n]);

  return null;
}

function HomePage() {
  return (
    <main className="app">
      <SiteNavbar />
      <HeroSection />
      <PartnersSection />
      <AboutPreviewSection />
      <ProductsSection />
      <BenefitsSection />
      <ContactSection />
      <FooterSection />
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageSettings />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products/:slug" element={<ProductDetailsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </BrowserRouter>
  );
}
